<script setup lang="ts">
const emit = defineEmits<{
  expand: [];
}>();
</script>

<template>
  <div class="content-break" @click="emit('expand')">
    <AppBtn variant="outline" size="sm">Czytaj dalej</AppBtn>
  </div>
</template>
